const translations = {
    de: {
        address: 'Adresse',
        add_events: 'Heutige Veranstaltungen hinzufügen',
        add_locations: 'Orte hinzufügen',
        all: 'Alle',
        all_locations: 'Alle Orte',
        and_others: 'und weitere...',
        appointment: 'Uhrzeit',
        appointments: 'Uhrzeiten',
        arbitrary: 'Zeitraum wählen',
        assume_selection: 'Auswahl übernehmen',
        automatic_geo_location: 'Standort automatisch bestimmen',
        back: 'Zurück',
        cancelled: 'Abgesagt',
        categories: 'Kategorien',
        category: 'Kategorie',
        clock: 'Uhr',
        contact: 'Kontakt',
        contact_form: 'Kontaktformular',
        contact_host: 'Veranstalter kontaktieren',
        copyright: '© ' + (new Date()).getFullYear() + ' Dresden Marketing Gesellschaft',
        customers: 'Über 4000+ Kunden vertrauen uns',
        customers_description: 'Was unsere Kunden über uns sagen',
        data_disclaimer_copy: 'Für den neuen Online-Veranstaltungskalender mussten wir große Datenmengen aus dem alten ins neue System übertragen. Aus technischen Gründen können eventuell Daten fehlen oder verschoben sein. Bitte überprüfen Sie Ihre Eintragungen. <a href=\'https://veranstaltungen-api.dresden.de/\' class=\'text-link\' target=\'_blank\'>Loginbereich für Veranstalter</a><br><br>Dieser Hinweis ist nur vorübergehend sichtbar. Sie können sich jederzeit über den Punkt "Veranstalterbereich" im <strong>Menu</strong> einloggen.<br>Danke!',
        data_disclaimer_headline: 'Wichtiger Hinweis',
        date: 'Datum',
        date_info: 'Zeitraum',
        date_range: 'Ich habe einen festen Zeitraum',
        date_range_label: 'Datumsbereich',
        date_range_time_label: 'Genaue Zeitspanne',
        date_range_time_close: 'Auswahl der Zeitspanne schließen',
        date_range_picker: {
            months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
            weekdaysLong: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
            weekdaysShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
            labels: {
                nextMonth: 'Nächster Monat',
                previousMonth: 'Letzter Monat',
            },
        },
        date_range_picker_description: 'Verwenden Sie die Pfeiltasten, um zwischen den Tagen im Kalender zu navigieren. Drücken Sie die Eingabetaste oder die Leertaste, um ein Start- und Enddatum auszuwählen.',
        day: 'Tag:',
        description: 'Beschreibung',
        discover_more: 'Mehr erfahren',
        event_calender: 'Veranstaltungskalender',
        event_calender_dresden_elbland: 'Veranstaltungskalender Dresden Elbland',
        event_dates_cancel_info: 'Informationen zu abgesagten oder verschobenen Veranstaltungen',
        event_location: 'Veranstaltungsort',
        event_multiple_dates_info: 'Diese Veranstaltung hat mehrere Termine. Sie finden alle Termine in der Detailansicht.',
        event_search: 'Veranstaltungssuche',
        event_search_description: 'Entdecken. Erleben. Genießen.',
        events: 'Veranstaltungen',
        events_dresden_elbland: 'Veranstaltungen Dresden Elbland',

        events_filter_form_description: 'Verwenden Sie dieses Formular, um Veranstaltungen nach Volltext, Adresse, Veranstaltungsdatum, Kategorie, Eintrittspreis und speziellen Stichworten zu filtern.',
        events_later: ({count}) => `${count} weitere Termine verfügbar`,
        fax: 'Fax:',
        filter_open_close: 'Filter öffnen / schließen',
        features: 'Eigenschaften',
        find_out_more: 'Mehr erfahren',
        find_out_more_host: 'Mehr erfahren zum Veranstalter',
        for_free: 'Eintritt frei',
        full_day: 'Ganztägig',
        fulltext_search: 'Volltextsuche',
        fulltext_search_events: 'Volltextsuche Veranstaltungen',
        gallery: 'Galerie',
        highlight: 'Highlight',
        highlights: 'Highlights',
        highlights_description: 'Die beliebtesten Veranstaltungen auf einen Blick',
        home: 'Startseite',
        homepage: 'Zur Startseite',
        homepage_filter_description: 'Verwenden Sie dieses Formular, um Veranstaltungen nach Volltext und Veranstaltungsdatum zu filtern.',
        host: 'Veranstalter',
        host_area: 'Veranstalterbereich',
        host_events: 'Veranstaltungen dieses Veranstalters',
        host_dresden_elbland: 'Veranstalter Dresden Elbland',
        host_location: 'Standort',
        ical_label: 'Termin merken',
        imprint: 'Impressum',
        in_range_of: 'in einem Umkreis von',
        list_layout_list: 'Liste',
        list_layout_grid: 'Kacheln',
        list_layout_map: 'Karte',
        list_page_title: 'Suchergebnisse',
        loading: 'Lade...',
        loading_events: 'Lade Veranstaltungen...',
        loading_locations: 'Lade Orte...',
        location: 'Veranstaltungsort',
        location_events: 'Veranstaltungen an diesem Ort',
        location_search: 'Adresse',
        locations: 'Orte',
        locations_dresden_elbland: 'Veranstaltungen Dresden Elbland',
        locations_filter_form_description: 'Verwenden Sie dieses Formular, um Veranstaltungsorte nach Volltext, Adresse, Öffnungszeiten und speziellen Stichworten zu filtern.',
        language_de: 'Deutsch',
        language_en: 'Englisch',
        main_page_title: 'Veranstaltungskalender Dresden\xa0Elbland',
        map_popup: 'Klicken Sie auf die Marker um mehr über das Event zu erfahren.',
        map_popup_locations: 'Klicken Sie auf die Marker um mehr über den Ort zu erfahren.',
        mapbox_consent_dialog: 'Zur Zeit ist das Anzeigen von Karten aufgrund Ihrer Einstellungen deaktiviert. Möchten Sie ' +
            'Ihre Einstellung für die Einbindung von Karten ändern und das Anzeigen von Karten erlauben?',
        navigation: 'Navigation',
        navigation_open_close: 'Navigation öffnen / schließen',
        navbar_filter_description: 'Verwenden Sie dieses Formular, um Veranstaltungen nach Volltext zu filtern.',
        newDate: 'Neuer Termin: ',
        newDateUnknown: 'Neuer Termin unbekannt',
        newest: 'Neuste',
        next_week: 'Nächste Woche',
        no: 'Nein',
        no_future_dates: 'Keine zukünftigen Termine bekannt.',
        no_location_results: ({listingTitle}) => `Es wurden leider keine ${listingTitle || 'Orte'} gefunden.`,
        no_results: 'Es wurden leider keine Veranstaltungen gefunden.',
        oldest: 'Älteste',
        online: 'Online',
        online_event: 'Online-Veranstaltung',
        opening_hours: 'Öffnungszeiten',
        opening_hours_info_label: 'Information zur den Öffnungszeiten',
        opening_hours_info: 'Bei der Suche nach geöffneten Einrichtungen werden nur die Einrichtungen angezeigt, für die auch\n' +
            'Öffnungszeiten hinterlegt wurden. Sonderöffnungszeiten z. B. in den Ferien oder an Feiertagen sowie\n' +
            'ständig geöffnete Angebote (z. B. Parks und Spielplätze) werden nicht berücksichtigt.',
        others: 'Sonstige',
        page_not_found_copy: 'Wir bitten für die Unannehmlichkeiten um Entschuldigung. Bitte versuchen Sie es später erneut.',
        page_not_found_headline: 'Bitte entschuldigen Sie, die angeforderte Seite wurde nicht gefunden.',
        phone: 'Tel:',
        play: 'Video Abspielen',
        rescheduled: 'Verschoben',
        price: 'Eintrittspreis',
        price_heigh: 'Preis (hoch zu niedrig)',
        price_low: 'Preis (niedrig zu hoch)',
        price_max: 'Maximaler Eintrittspreis: ',
        prices_from: 'ab;',
        privacy: 'Datenschutz',
        read_less: '- weniger lesen',
        read_more: 'Weiterlesen',
        recommendations: 'Unsere Vorschläge für Sie',
        recommendations_description: 'Finden Sie Veranstaltungen basierend auf der Kategorie',
        results: 'Ergebnisse:',
        results_found: 'Veranstaltungen gefunden',
        scrollToTop: 'nach oben scrollen',
        search: 'Suchen',
        search_info: 'Suchbegriff eingeben und/oder Datum auswählen:',
        search_placeholder: 'Suchen',
        search_results_for: 'Suchergebnisse für',
        search_events: 'Veranstaltungen suchen',
        search_events_with_keyword: 'Suche nach Veranstalten mit Schlüsselwort',
        select_category: 'Kategorie wählen',
        select_weekday: 'Wochentag wählen',
        select_radius: 'Eingabe Adresse mit Radius',
        service: 'Service',
        show_all: 'Alle ansehen',
        show_more_events: 'Mehr Veranstaltungen anzeigen',
        show_more_locations: 'Mehr Orte anzeigen',
        show_playgrounds: 'Spielplätze anzeigen',
        sort_by: 'Sortieren nach',
        special_opening_hours: 'Spezielle Öffnungszeiten',
        starting_at: 'ab',
        tags: 'Schlagwörter',
        terms: 'Nutzungsbedingungen',
        this_weekend: 'Dieses Wochenende',
        ticket_button: 'Tickets',
        time: 'Uhrzeit:',
        tmgsLogoAltText: 'Sachsen. Land von Welt.',
        today: 'Heute',
        to_the_event: 'Zur Veranstaltung',
        to_the_location: 'Zum Veranstaltungsort',
        tomorrow: 'Morgen',
        undefined: 'Kein Preis vorhanden',
        view_all_events: 'Alle Veranstaltungen anschauen',
        video: 'Video',
        video_consent_dialog: ({videoProvider}) => `Zur Zeit ist das Abspielen von ${videoProvider}-Videos aufgrund Ihrer ` +
            `Einstellungen deaktiviert. Möchten Sie Ihre Einstellung für ${videoProvider}-Videos ändern und ` +
            'das Abspielen des Videos erlauben?',
        monday: 'Montag',
        tuesday: 'Dienstag',
        wednesday: 'Mittwoch',
        thursday: 'Donnerstag',
        friday: 'Freitag',
        saturday: 'Samstag',
        sunday: 'Sonntag',
        yes: 'Ja',
        z_a: 'Z bis A',
    },
    en: {
        address: 'Address',
        add_events: 'Add today events',
        add_locations: 'Add locations',
        all: 'All',
        all_locations: 'All locations',
        and_others: 'and others...',
        appointment: 'Appointment',
        appointments: 'Appointments',
        arbitrary: 'Select a date',
        assume_selection: 'assume selection',
        automatic_geo_location: 'Determine location automatically',
        back: 'Back',
        categories: 'Categories',
        category: 'Category',
        cancelled: 'Cancelled',
        clock: ' ', // Leave empty, because the translation clock/o'clock is not useful in our use case
        contact: 'Contact',
        contact_form: 'Contact form',
        contact_host: 'Contact host',
        copyright: '© ' + (new Date()).getFullYear() + ' Dresden Marketing Gesellschaft',
        customers: 'Trusted by over 4000+ customers',
        customers_description: 'What our customers say about us',
        data_disclaimer_copy: 'For the new online event calendar we had to transfer large amounts of data from the old system to the new one. For technical reasons, data may be missing or moved. Please check your entries. <a href=\'https://veranstaltungen-api.dresden.de/\' class=\'text-link\' target=\'_blank\'>Login area for organizers</a><br><br> This notice is only temporarily visible. You can log in at any time by clicking on "Organizer area" in the <strong>Menu</strong>.<br>Thank you!\n',
        data_disclaimer_headline: 'Important note',
        date: 'Date',
        date_info: 'Period',
        date_range: 'I have a fixed period',
        date_range_label: 'Datenrange',
        date_range_time_label: 'Exact time period',
        date_range_time_close: 'Close selection of time period',
        date_range_picker_description: 'Use the arrow keys to navigate between the days in the calendar. Press the Enter key or the space bar to select a start and end date.',
        day: 'Day',
        description: 'Description',
        discover_more: 'Find out more',
        enter_start_date: 'Eingabe Startdatum',
        enter_end_date: 'Eingabe Enddatum',
        event_calender_dresden_elbland: 'event calender Dresden Elbland',
        event_dates_cancel_info: 'Information on cancelled or rescheduled events',
        event_location: 'Event location',
        event_multiple_dates_info: 'This event has multiple dates. You can find all available dates in the detail view.',
        event_search: 'Event search',
        event_search_description: 'Discover. Experience. Enjoy.',
        events: 'Events',
        events_filter_form_description: 'Use this form to filter events by fulltext, address, event-date, category, entry-fee and special keywords.',
        events_later: ({count}) => `${count} other dates available`,
        fax: 'fax:',
        filter_open_close: 'Filter open/closed',
        features: 'Features',
        find_out_more: 'Find out more',
        find_out_more_host: 'Find out more about the host',
        for_free: 'Free',
        full_day: 'Full day',
        fulltext_search: 'Full text search',
        fulltext_search_events: 'Full text search events',
        gallery: 'Gallery',
        highlight: 'Highlight',
        highlights: 'Highlights',
        highlights_description: 'The most popular events at a glance',
        home: 'Home',
        homepage: 'To homepage',
        homepage_filter_description: 'Use this form to filter events by full text and event date.',
        host: 'Host',
        host_area: 'Organizer area',
        host_events: 'Events of this organizer',
        host_location: 'Location',
        ical_label: 'Remember date',
        imprint: 'Imprint',
        in_range_of: 'within a radius of',
        list_page_title: 'Search results',
        loading_events: 'Loading events...',
        loading_locations: 'Loading locations...',
        location_events: 'Events at this location',
        location_search: 'Address',
        locations: 'Locations',
        locations_filter_form_description: 'Use this form to filter event locations by fulltext, address, opening-hours and special keywords.',
        language_de: 'German',
        language_en: 'English',
        main_page_title: 'Event calendar Dresden\xa0Elbland',
        map_popup: 'Click on the markers to learn more about the event.',
        map_popup_locations: 'Click on the markers to learn more about the location.',
        mapbox_consent_dialog: 'Currently, the display of maps is disabled due to your settings. Do you want to change your ' +
            'map inclusion setting and allow showing maps?',
        navigation: 'Navigation',
        navigation_open_close: 'Open / close navigation',
        navbar_filter_description: 'Use this form to filter events by full text.',
        newDate: 'New date: ',
        newDateUnknown: 'New date unknown',
        newest: 'Newest',
        next_week: 'Next week',
        no: 'No',
        no_future_dates: 'No future dates available.',
        no_location_results: 'Unfortunately no locations were found.',
        no_results: 'Unfortunately no events were found.',
        oldest: 'Oldest',
        online: 'Online',
        online_event: 'Online-Event',
        opening_hours: 'Opening hours',
        opening_hours_info_label: 'Information on opening hours',
        opening_hours_info: 'When searching for open facilities, only those facilities are displayed for which opening hours have been entered.\n' +
            'opening hours have been entered. Special opening hours, e.g. during holidays or on public holidays, as well as permanent\n' +
            'permanently open facilities (e.g. parks and playgrounds) are not taken into account.',
        others: 'Others',
        page_not_found_copy: 'We apologize for the inconvenience. Please try again later.',
        page_not_found_headline: 'Please excuse us, the requested page was not found.',
        phone: 'tel:',
        play: 'Play video',
        rescheduled: 'Rescheduled',
        price: 'Ticket price',
        price_heigh: 'Price (high to low)',
        price_low: 'Price (low to high)',
        price_max: 'Ticket price max: ',
        prices_from: 'from',
        privacy: 'Privacy policy',
        read_less: '- read less',
        read_more: 'Read more',
        recommendations: 'Our suggestions for you',
        recommendations_description: 'Find events based on the category',
        results: 'Results:',
        results_found: 'Events found',
        scrollToTop: 'scroll to the top',
        search: 'Search',
        search_info: 'Enter search term and/or select date:',
        search_placeholder: 'Search',
        search_results_for: 'Results for',
        search_events: 'Search for events',
        search_events_with_keyword: 'Search for events with keyword\'',
        select_category: 'Select a category',
        select_weekday: 'select weekday',
        select_radius: 'Enter address with radius',
        service: 'Service',
        show_all: 'View all',
        show_more_events: 'Show more events',
        show_more_locations: 'Show more locations',
        show_playgrounds: 'Show playgrounds',
        sort_by: 'Sort by',
        special_opening_hours: 'Special opening hours',
        starting_at: 'Starting at',
        tags: 'Keywords',
        terms: 'Terms of use',
        this_weekend: 'This weekend',
        ticket_button: 'Tickets',
        time: 'Time',
        tmgsLogoAltText: 'Saxony. State Of The Arts.',
        today: 'Today',
        to_the_event: 'To the event',
        to_the_location: 'To the event-location',
        tomorrow: 'Tomorrow',
        undefined: 'Price undefined',
        view_all_events: 'View all Events',
        video: 'Video',
        video_consent_dialog: ({videoProvider}) => `Currently, playing ${videoProvider} videos is disabled due ` +
            `to your settings. Do you want to change your setting for ${videoProvider} videos and allow playing the video?`,
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        sunday: 'Sunday',
        yes: 'Yes',
        z_a: 'Z to A',
    }
};

export default translations;
